import { Panel } from './Panel';
import { RadioButton } from '../ui';
import { LoadContext, Disposable } from "../../../utils";
import { Settings } from "../../../settings";
import { Sprite, Texture, NineSlicePlane } from 'pixi.js';
import { Focusable, fonts, UILabel, InteractiveWrapper, StyledBitmapText } from "../../../ui";
import { FONTS } from '../../../constants';
import { Game } from '../../../game';

export class TextDisplay extends Panel
{
    private sizeLabel: UILabel;
    private smallButton:RadioButton;
    private mediumButton:RadioButton;
    private largeButton:RadioButton;

    private colorLabel: UILabel;
    private wOnBButton:RadioButton;
    private yOnBButton:RadioButton;
    private bOnWButton:RadioButton;

    private previewText:StyledBitmapText;
    private previewBG:Sprite;

    public static preload() {
        LoadContext.current.add('Settings', './assets/accessibility/Settings{size}.json');
    }

    constructor( game:Game )
    {
        super(
            game,
            "",
            null,
            {width: 692, height: 501}
        );

        const loader = LoadContext.current;
        const icon:Sprite = new Sprite( loader.getTexture('icon_onscreentxt', 'Settings') );
        icon.position.set( this.icon_x - 20, this.icon_y );
        this.addChild( icon );

        // TEXT SIZE
        this.sizeLabel = new UILabel('Text Size', fonts.SettingsGroupTitle, loader.getTexture('icon_question', 'Settings'));
        this.sizeLabel.position.set(190, 40);
        this.disposables.add(new InteractiveWrapper(this.sizeLabel, {
            onHover: async () => {
                await this.game.vo.playHighlight('CYB_Panel1_TextSize');
            },
            onFocus: async () => {
                await this.game.vo.playHighlight('CYB_Panel1_TextSize');
                // if not a real pointerover from tab focus and AD is enabled, play another bit
                await this.game.vo.playHighlight('CYB_Panel_Explain');
            },
            onTap: async () => {
                this.game.vo.stop();
                await this.game.vo.playVO('CYB_Panel1_TextSize_Explanation', true);
            },
            onActivate: async () => {
                this.game.vo.stop();
                await this.game.vo.playVO('CYB_Panel1_TextSize_Explanation', true);
                await this.game.vo.playVO('CYB_Panel1_TextSize_Settings', true);
            }
        }));
        this.addChild(this.sizeLabel);

        this.smallButton = new RadioButton( "A", {fontName: 'AsapMedium', fontSize: 22 } );
        this.smallButton.position.set( 160, 150 );
        this.disposables.add(new InteractiveWrapper(this.smallButton, {
            onHover: () => {
                this.playRadioHover( this.smallButton, "CYB_Panel1_Small" );
            },
            onFocus: () => {
                this.playRadioHover( this.smallButton, "CYB_Panel1_Small", true );
            },
            onTap: async () => {
                this.game.vo.stop();
                this.setTextSize(Settings.TextSize.SMALL);
                this.game.logEvent("change_setting", "text_size_small");
                this.playRadioVO( this.smallButton, "CYB_Panel1_Small" );
            }
        }));
        this.smallButton.createHitCircle(1);
        this.addChild( this.smallButton );

        this.mediumButton = new RadioButton( "A", {fontName: 'AsapMedium', fontSize: 30 } );
        this.mediumButton.position.set( 160, 230 );
        this.disposables.add(new InteractiveWrapper(this.mediumButton, {
            onHover: () => {
                this.playRadioHover( this.mediumButton, "CYB_Panel1_Medium" );
            },
            onFocus: () => {
                this.playRadioHover( this.mediumButton, "CYB_Panel1_Medium", true );
            },
            onTap: async () => {
                this.game.vo.stop();
                this.setTextSize(Settings.TextSize.MEDIUM);
                this.game.logEvent("change_setting", "text_size_medium");
                this.playRadioVO( this.mediumButton, "CYB_Panel1_Medium" );
            }
        }));
        this.mediumButton.createHitCircle(1);
        this.addChild( this.mediumButton );

        this.largeButton = new RadioButton( "A", {fontName: 'AsapMedium', fontSize: 46 } );
        this.largeButton.position.set( 160, 310 );
        this.disposables.add(new InteractiveWrapper(this.largeButton, {
            onHover: () => {
                this.playRadioHover( this.largeButton, "CYB_Panel1_Large" );
            },
            onFocus: () => {
                this.playRadioHover( this.largeButton, "CYB_Panel1_Large", true );
            },
            onTap: async () => {
                this.game.vo.stop();
                this.setTextSize(Settings.TextSize.LARGE);
                this.game.logEvent("change_setting", "text_size_large");
                this.playRadioVO( this.largeButton, "CYB_Panel1_Large" );
            }
        }));
        this.largeButton.createHitCircle(1);
        this.addChild( this.largeButton );

        // TEXT STYLE
        this.colorLabel = new UILabel('Text Color', fonts.SettingsGroupTitle, loader.getTexture('icon_question', 'Settings'));
        this.colorLabel.position.set(470, 40);
        this.disposables.add(new InteractiveWrapper(this.colorLabel, {
            onHover: async () => {
                await this.game.vo.playHighlight('CYB_Panel1_TextColor');
            },
            onFocus: async () => {
                await this.game.vo.playHighlight('CYB_Panel1_TextColor');
                // if not a real pointerover from tab focus and AD is enabled, play another bit
                await this.game.vo.playHighlight('CYB_Panel_Explain');
            },
            onTap: async () => {
                this.game.vo.stop();
                await this.game.vo.playVO('CYB_Panel1_TextColor_Explanation', true);
            },
            onActivate: async () => {
                this.game.vo.stop();
                await this.game.vo.playVO('CYB_Panel1_TextColor_Explanation', true);
                await this.game.vo.playVO('CYB_Panel1_TextColor_Settings', true);
            }
        }));
        this.addChild(this.colorLabel);

        this.wOnBButton = new RadioButton( "Aa", {fontName: 'AsapMedium', fontSize: 30, tint: 0xffffff }, 0x000000/*0xaaaaaa*/ );
        this.wOnBButton.position.set( 440, 150 );
        this.disposables.add(new InteractiveWrapper(this.wOnBButton, {
            onHover: () => {
                this.playRadioHover( this.wOnBButton, "CYB_Panel1_WhiteText" );
            },
            onFocus: () => {
                this.playRadioHover( this.wOnBButton, "CYB_Panel1_WhiteText", true );
            },
            onTap: async () => {
                this.game.vo.stop();
                this.setTextStyle(Settings.TextStyle.WHITE_ON_BLACK);
                this.game.logEvent("change_setting", "text_color_white_on_black");
                this.playRadioVO( this.wOnBButton, "CYB_Panel1_WhiteText" );
            }
        }));
        this.wOnBButton.createHitCircle(1);
        this.addChild( this.wOnBButton );

        this.yOnBButton = new RadioButton( "Aa", {fontName: 'AsapMedium', fontSize: 30, tint: 0xffff00 }, 0x000000 );
        this.yOnBButton.position.set( 440, 230 );
        this.disposables.add(new InteractiveWrapper(this.yOnBButton, {
            onHover: () => {
                this.playRadioHover( this.yOnBButton, "CYB_Panel1_YellowText" );
            },
            onFocus: () => {
                this.playRadioHover( this.yOnBButton, "CYB_Panel1_YellowText", true );
            },
            onTap: async () => {
                this.game.vo.stop();
                this.setTextStyle(Settings.TextStyle.YELLOW_ON_BLACK);
                this.game.logEvent("change_setting", "text_color_yellow_on_black");
                this.playRadioVO( this.yOnBButton, "CYB_Panel1_YellowText" );
            }
        }));
        this.yOnBButton.createHitCircle(1);
        this.addChild( this.yOnBButton );

        this.bOnWButton = new RadioButton( "Aa", {fontName: 'AsapMedium', fontSize: 30 }, new NineSlicePlane(LoadContext.current.getSpritesheet('Settings').textures['bOnWBG'], 4, 4, 4, 4) );
        this.bOnWButton.position.set( 440, 310 );
        this.disposables.add(new InteractiveWrapper(this.bOnWButton, {
            onHover: () => {
                this.playRadioHover( this.bOnWButton, "CYB_Panel1_BlackText" );
            },
            onFocus: () => {
                this.playRadioHover( this.bOnWButton, "CYB_Panel1_BlackText", true );
            },
            onTap: async () => {
                this.game.vo.stop();
                this.setTextStyle(Settings.TextStyle.BLACK_ON_WHITE);
                this.game.logEvent("change_setting", "text_color_black_on_white");
                this.playRadioVO( this.bOnWButton, "CYB_Panel1_BlackText" );
            }
        }));
        this.bOnWButton.createHitCircle(1);
        this.addChild( this.bOnWButton );

        // update so that all radio buttons reflect current settings
        this.updateToMatchSetting();

        this.previewBG = new Sprite(Texture.WHITE);
        this.previewBG.tint = FONTS.TextPreview[this.settings.textStyle.value].bg;
        this.previewBG.anchor.set(0.5, 0.5);
        this.previewBG.position.set(340, 420);
        this.previewBG.width = 500;
        this.previewBG.height = 80;
        this.addChild(this.previewBG);
        this.disposables.add(Disposable.fromPropertySubscription(this.settings.textStyle, (value) => {
            this.previewBG.tint = FONTS.TextPreview[value].bg;
            this.previewText.tint = FONTS.TextPreview[value].text;
        }));

        this.previewText = new StyledBitmapText('Sample Text', fonts.TextPreview);
        this.previewText.position.copyFrom(this.previewBG.position);
        this.previewText.anchor.set(0.5, 0.6);
        this.addChild(this.previewText);
    }

    private setTextSize( value:Settings.TextSize )
    {
        this.smallButton.active = value === Settings.TextSize.SMALL;
        this.mediumButton.active = value === Settings.TextSize.MEDIUM;
        this.largeButton.active = value === Settings.TextSize.LARGE;

        if( value != this.settings.textSize.value ) {
            this.settings.textSize.value = value;
        }
    }

    private setTextStyle( value:Settings.TextStyle )
    {
        this.wOnBButton.active = value === Settings.TextStyle.WHITE_ON_BLACK;
        this.yOnBButton.active = value === Settings.TextStyle.YELLOW_ON_BLACK;
        this.bOnWButton.active = value === Settings.TextStyle.BLACK_ON_WHITE;

        if( value != this.settings.textStyle.value ) {
            this.settings.textStyle.value = value;
        }
    }

    getFocusItems():Focusable[]
    {
        let items = super.getFocusItems();
        return items.concat( [
            this.sizeLabel,
            this.smallButton,
            this.mediumButton,
            this.largeButton,
            this.colorLabel,
            this.wOnBButton,
            this.yOnBButton,
            this.bOnWButton
        ] );
    }

    updateToMatchSetting()
    {
        super.updateToMatchSetting();
        this.setTextSize( this.settings.textSize.value );
        this.setTextStyle( this.settings.textStyle.value );
    }

    destroy()
    {
        super.destroy();
    }
}